import React from "react"
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"

const StaffDataTableActionButton = ({ action }) => {
  return (
    <Button
      variant="outlined"
      onClick={action.onAction}
      disabled={action.disabled || action.loading}
      sx={{
        border: "1px solid rgba(201,168,76,0.4)",
        color: "#c9a84c",
        bgcolor: "transparent",
        fontSize: "0.6rem",
        textTransform: "uppercase",
        letterSpacing: "0.15em",
        fontFamily: "'Josefin Sans', sans-serif",
        px: 2, py: 0.6,
        "&:hover": { bgcolor: "rgba(201,168,76,0.1)", borderColor: "#c9a84c" },
      }}
    >
      {action.name}
    </Button>
  )
}

export default StaffDataTableActionButton
